// extracted by mini-css-extract-plugin
module.exports = {"root":"Label_root__3mK3d","disabled":"Label_disabled__1nXb7"};